<template>
  <div>
    <v-layout row wrap>
      <v-flex p-t-30>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <v-btn icon @click="openBox()" right absolute>
            <v-icon>unfold_more</v-icon>
          </v-btn>
          <h1 class="text-info font-size-18">
            Qualificação
            <strong>Técnica</strong>
          </h1>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-show="showBox">
      <v-flex infoDados>
        <v-card>
          <v-data-table
            :headers="cabecalhoQualificacaoTecnica"
            :items="model.qualificacaoTecnica"
            :hide-actions="true"
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td
                class="text-xs-left"
              >{{retornaNomeQualificacaoTecnica(listaDocsQualificacaoTecnica,props.item.codDocumento)}}</td>
              <td class="text-xs-left">{{props.item.numDocumento}}</td>
              <td class="text-xs-center" v-bind:class="{'dataVencida':verificaDataVencida(props.item.dtVencimento)}">{{props.item.dtVencimento | dataFormatada}}</td>
              <td class="text-xs-center naoImprimir">               
                <a 
                  v-show="props.item.arquivoUpload && props.item.arquivoUpload !== 'Não Encontrado'"
                >
                  <v-icon 
                    :color="
                     props.item.qualificacaoTecnicaSituacao === 2
                        ? 'blue' 
                        : (props.item.qualificacaoTecnicaSituacao === 1 
                          ? 'red' 
                          : 'grey')
                    "
                    :disabled="!(
                      props.item.arquivoUpload.includes('https') || 
                      (props.item.qualificacaoTecnicaSituacao === 1 && props.item.arquivoUpload.includes('.pdf'))
                    )"
                      @click.native="handleIconClick(props.item.arquivoUpload,props.item.qualificacaoTecnicaSituacao)"
                  >
                    attach_file
                  </v-icon>
                </a>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import fornecedorService from "../../../services/fornecedorService";
import dominioService from "../../../services/dominioService";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */

export default {
  name: "resumo-qualificacao-tecnica",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    dominio: Object,
    enums: Object
  },
  created() /*Metodo de start do componente*/{
    this.getListaDocsQualificacaoTecnica();
  },
  data() {//Declaracao de variaveis
    return {
      listaDocsQualificacaoTecnica: {},
      showBox: true,
    };
  },
  methods: {//Declaracao de todos os metodos
    openBox() {
      //abrir o box dos documentos
      this.showBox = !this.showBox;
    },
    handleIconClick(arquivo,situacao) {
        if (arquivo.includes('https')) {
          window.open(arquivo, '_blank');
        } else if (situacao === 1 && arquivo.includes('.pdf')) {
          this.baixarArquivo(arquivo);
        }
      },  
  
     baixarArquivo(arquivo) {  
      const numCgcFornecedor = this.model.numCgcFornecedor.replace(/[\W_]+/g, "") ;
         
      fornecedorService.baixarArquivo(arquivo,numCgcFornecedor);
      },
    getListaDocsQualificacaoTecnica() {
      //resgatar a lista de qualificacao tecnica
      dominioService
        .getListaDocsQualificacaoTecnica(this.model.familiaSolicitacao)
        .then(response => { /*resposta do servico*/
          this.listaDocsQualificacaoTecnica = response.data; /*dados de retorno*/
        });
    },
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.infoDados .v-card {
  padding: 15px;
}

.infoDados .linhaInfo {
  display: block;
  padding: 5px 0;
}

.theme--light.v-table thead {
  background: none;
}





</style>


